import styled from 'styled-components';
import React from 'react';

interface FlexibleWrapperProps {
  imagePath: string;
  backgroundColor: string;
  children: React.ReactNode;
}

const OuterWrapper = styled.div<Omit<FlexibleWrapperProps, 'children'>>`
  background-color: ${(props) => props.backgroundColor};
  mask-image: url(${(props) => props.imagePath});
  mask-size: 100% 100%;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-image: url(${(props) => props.imagePath});
  -webkit-mask-size: 100% 100%;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
`;

const FlexibleWrapper: React.FC<FlexibleWrapperProps> = ({
  imagePath,
  backgroundColor,
  children,
  ...rest
}) => {
  return (
    <OuterWrapper
      imagePath={imagePath}
      backgroundColor={backgroundColor}
      {...rest}
    >
      {children}
    </OuterWrapper>
  );
};

export default FlexibleWrapper;
